// Application status constants
export const APPLICATION_STATUSES = {
  APPLIED: 'applied' as const,
  INTERVIEW: 'interview' as const,
  OFFER: 'offer' as const,
  REJECTED: 'rejected' as const,
};

// Application source constants
export const APPLICATION_SOURCES = {
  LINKEDIN: 'linkedin' as const,
  INDEED: 'indeed' as const,
  GREENHOUSE: 'greenhouse' as const,
  GENERIC: 'generic' as const,
  MANUAL: 'manual' as const,
};

// File type constants
export const FILE_TYPES = {
  RESUME: 'resume' as const,
  COVER_LETTER: 'cover_letter' as const,
};

// Extension message types
export const EXTENSION_MESSAGES = {
  APPLICATION_DETECTED: 'APPLICATION_DETECTED' as const,
  UPLOAD_FILES: 'UPLOAD_FILES' as const,
  GET_AUTH_STATE: 'GET_AUTH_STATE' as const,
  SIGN_IN: 'SIGN_IN' as const,
  SIGN_OUT: 'SIGN_OUT' as const,
  SAVE_APPLICATION: 'SAVE_APPLICATION' as const,
  GET_STATS: 'GET_STATS' as const,
};

// Firestore collection names
export const COLLECTIONS = {
  USERS: 'users',
  APPLICATIONS: 'applications',
  FILES: 'files',
  STATISTICS: 'statistics',
};

// Storage paths
export const STORAGE_PATHS = {
  RESUMES: (userId: string, fileId: string, timestamp: string, fileName: string) =>
    `users/${userId}/resumes/${fileId}_${timestamp}_${fileName}`,
  COVER_LETTERS: (userId: string, fileId: string, timestamp: string, fileName: string) =>
    `users/${userId}/cover-letters/${fileId}_${timestamp}_${fileName}`,
};

// File constraints
export const FILE_CONSTRAINTS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_MIME_TYPES: ['application/pdf'],
  ALLOWED_EXTENSIONS: ['.pdf'],
};

// Status colors for UI (Tailwind classes)
export const STATUS_COLORS = {
  applied: 'bg-blue-100 text-blue-800',
  interview: 'bg-yellow-100 text-yellow-800',
  offer: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
};

// Status display labels
export const STATUS_LABELS = {
  applied: 'Applied',
  interview: 'Interview',
  offer: 'Offer',
  rejected: 'Rejected',
};

// Generic detector confidence threshold
export const GENERIC_DETECTOR_THRESHOLD = 0.7;

// Job site patterns for generic detector
export const JOB_FORM_KEYWORDS = [
  'apply',
  'application',
  'job application',
  'submit application',
  'career',
  'careers',
];

export const FILE_INPUT_KEYWORDS = [
  'resume',
  'cv',
  'curriculum vitae',
  'cover letter',
  'covering letter',
];

export const SUCCESS_KEYWORDS = [
  'thank you',
  'application submitted',
  'success',
  'received your application',
  'application received',
];
